export interface PuntoReglamento {
  icono: string;
  titulo: string;
  texto: string;
}

export interface DocumentoReglamento {
  id: string;
  titulo: string;
  descripcion: string;
  tipo: string;      // "Reglamento general", "Play Off", "Mini torneo", etc.
  fecha: string;
  icono: string;     // clase Font Awesome
  archivo: string;   // ruta al PDF en assets
  puntos: PuntoReglamento[];
}

/*
  Para agregar un nuevo documento (play off, mini torneo, etc.):
  1. Copia su PDF a src/assets/reglamento/
  2. Agrega un objeto mas a este arreglo con su titulo, tipo, ruta y puntos.
  La vista se arma sola: el selector, los puntos destacados y el visor.
*/
export const DOCUMENTOS_REGLAMENTO: DocumentoReglamento[] = [
  {
    id: 'reglamento-general-2025',
    titulo: 'Reglamento Oficial 2025',
    descripcion: 'Normas que regulan la organización, participación y desarrollo de la Liga Infantil y Juvenil de Béisbol Yucatán A.C.',
    tipo: 'Reglamento general',
    fecha: 'Octubre 2025',
    icono: 'fas fa-book',
    archivo: './assets/reglamento/reglamento-2025.pdf',
    puntos: [
      {
        icono: 'fas fa-medal',
        titulo: 'Formación integral',
        texto: 'Fomentar el béisbol en un ambiente de disciplina, respeto, equidad y sana convivencia entre jugadores, padres y entrenadores.'
      },
      {
        icono: 'fas fa-calendar-alt',
        titulo: 'Dos campeonatos al año',
        texto: 'La Liga convoca a dos campeonatos de invitación cada año: el primero en febrero y el segundo en agosto.'
      },
      {
        icono: 'fas fa-file-signature',
        titulo: 'Documentos de inscripción',
        texto: 'Acta de nacimiento, CURP, constancia de estudios, dos fotografías, ficha firmada y comprobante del seguro de juego.'
      },
      {
        icono: 'fas fa-users',
        titulo: 'Cuerpo técnico',
        texto: 'Cada equipo registra tres adultos: manejador, ayudante y representante oficial ante la Liga.'
      },
      {
        icono: 'fas fa-venus-mars',
        titulo: 'Equipos mixtos',
        texto: 'Se permite la participación de jugadoras desde T-Ball hasta Infantil Menor (9–10 años) en cualquier posición.'
      },
      {
        icono: 'fas fa-shield-alt',
        titulo: 'Conducta y sanciones',
        texto: 'Reglas sobre conductas antideportivas, seguridad en la unidad deportiva y convivencia en redes sociales.'
      }
    ]
  }
];
